// extracted by mini-css-extract-plugin
export default {"logo":"styles_logo__xHzjc","menu":"styles_menu__C0cA2","footer":"styles_footer__r4XqO","footerLink":"styles_footerLink__+8Czr"};